const brlFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  maximumFractionDigits: 2,
});

const compactFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  notation: 'compact',
  maximumFractionDigits: 1,
});

const integerFormatter = new Intl.NumberFormat('pt-BR');

export function formatBRL(value: number): string {
  return brlFormatter.format(value);
}

export function formatBRLCompact(value: number): string {
  return compactFormatter.format(value);
}

export function formatInteger(value: number): string {
  return integerFormatter.format(value);
}
